import { type EChartsExtensionInstallRegisters } from 'echarts';
import { getInstanceById } from 'echarts/core';
import formatLabel from './formatLabel/index';

/**
 * 矩形树图label扩展
 */
export function treemapExtensionInstall(registers: EChartsExtensionInstallRegisters) {
  registers.registerUpdateLifecycle('series:afterupdate', (ecModel, api) => {
    const ecIns = getInstanceById(api.getId());
    const seriesModel = ecModel.getComponent('series', 0);
    if ((seriesModel?.option as any)?.dvLabelType) {
      const view = (ecIns as any).getViewOfSeriesModel(seriesModel);
      formatLabel((seriesModel.option as any).dvLabelType, view.group, seriesModel);
    }
  });
}
